export default __webpack_public_path__ + "static/media/52.5b930378.png";